import React from "react";

export default function ActiveFilterChips({ chips, onClearAll }) {
  if (!chips || chips.length === 0) {
    return null;
  }

  return (
    <ul className="nfl-chips" aria-label="Active filters">
      {chips.map((chip) => (
        <li key={chip.key} className="nfl-chip">
          {chip.color ? (
            <span
              className="nfl-chip-swatch"
              style={{ background: chip.color }}
              aria-hidden="true"
            />
          ) : null}
          <span>{chip.label}</span>
          <button
            type="button"
            className="nfl-chip-remove"
            onClick={chip.onRemove}
            aria-label={`Remove ${chip.label}`}
          >
            ×
          </button>
        </li>
      ))}
      {onClearAll ? (
        <li>
          <button type="button" className="nfl-link-button" onClick={onClearAll}>
            Clear
          </button>
        </li>
      ) : null}
    </ul>
  );
}
